module.exports = __webpack_public_path__ + "static/media/20euro.fb6f32db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/20euro.jpg
// module id = 930
// module chunks = 0